module.exports = __webpack_public_path__ + "static/media/sauraj.8073ba79.png";